import { projectPrivate } from '../../higher-order-components/projectPrivate'
import { PageProps } from '..'
import { useProjectPrivateContext } from '../../context/projectContext'
import UnitPricePerProjectPartnersView from './view'

type Props = PageProps

const UnitPricePerProjectPartners = (props: Props) => {
  const { project } = useProjectPrivateContext()

  return (
    <UnitPricePerProjectPartnersView {...props} projectUuid={project.uuid} />
  )
}

export default projectPrivate(UnitPricePerProjectPartners)
